import { render, staticRenderFns } from "./MainContentWrapper.vue?vue&type=template&id=1135c7f1&scoped=true"
var script = {}
import style0 from "./MainContentWrapper.vue?vue&type=style&index=0&id=1135c7f1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1135c7f1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1135c7f1')) {
      api.createRecord('1135c7f1', component.options)
    } else {
      api.reload('1135c7f1', component.options)
    }
    module.hot.accept("./MainContentWrapper.vue?vue&type=template&id=1135c7f1&scoped=true", function () {
      api.rerender('1135c7f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/components/main-content-wrapper/MainContentWrapper.vue"
export default component.exports